export default "__VITE_ASSET__Cdppnw4V__"